import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { DEFAULT_HOME_ROUTE } from '../../config/navAccessMap';
import { useEffectiveAccess } from '../../agenticsaas/contexts/EffectiveAccessContext';

export default function AccessDenied({ navId }) {
  const { subscription } = useEffectiveAccess();
  const planName = subscription?.plan_display_name;

  return (
    <div className="flex-1 flex items-center justify-center py-24 px-4">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-50">
          <ShieldOff className="h-7 w-7 text-red-600" aria-hidden />
        </div>
        <h1 className="text-xl font-semibold text-gray-900">Access restricted</h1>
        <p className="mt-2 text-sm text-gray-600">
          Your role or {planName ? `${planName} plan` : 'subscription'} does not include access to this area
          {navId ? ` (${navId})` : ''}. Contact your organization administrator or upgrade your plan.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to={DEFAULT_HOME_ROUTE}
            className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Go to dashboard
          </Link>
          <Link
            to="/subscription"
            className="inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            View subscription
          </Link>
        </div>
      </div>
    </div>
  );
}
